import type { GameDef } from '../registry';
import { formatTime } from './engine';

/** the picker's view of the game; the view imports this and the registry imports index.ts */
export const tacoSlapDef: Omit<GameDef, 'mount'> = {
  id: 'tacoslap',
  title: 'Taco Slap',
  icon: '🌮',
  blurb: 'Chant taco · cat · goat · cheese · pizza — tap the word, slap the match, and shed your whole pile against the clock.',
  howTo: [
    'Cards flip from your pile onto the table. The chant goes taco, cat, goat, cheese, pizza, and back around.',
    'Tap the chant word (bottom row) for each card. If the card IS the word, slap the card instead.',
    '🦍 Gorilla: double-tap (beat your chest). 🐙 Octopus: press & hold (all hands on the table). 🦄 Unicorn: swipe up (horn up).',
    'A correct slap or gesture throws the whole pile away for good. A wrong move, or hesitating, puts the pile back under yours plus 2 seconds.',
    'Empty your pile. The clock is your score — fastest time wins the leaderboard.',
  ],
  scoreLabel: 'time',
  lowerIsBetter: true,
  formatScore: formatTime,
};
